import { useState, useEffect } from "react";
import { ticker } from "@/mocks/home";

const navLinks = [
  { label: "背后真相", href: "#truth" },
  { label: "未解之谜", href: "#mystery" },
  { label: "知情人士", href: "#insider" },
  { label: "实时深扒", href: "#live" },
  { label: "热聊", href: "#talk" },
  { label: "吃瓜榜", href: "#rank" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const marqueeItems = [...ticker, ...ticker, ...ticker];

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      {/* 更新条压顶：实时快讯滚动条 */}
      <div className="flex items-stretch overflow-hidden border-b border-primary-500/30 bg-background-900/95 backdrop-blur">
        <div className="flex items-center gap-2 bg-primary-500 px-3 py-1.5 md:px-4">
          <i className="ri-radar-line text-sm text-background-950"></i>
          <span className="font-heading text-xs font-bold tracking-wide text-background-950">快讯</span>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="animate-marquee flex w-max items-center gap-10 py-1.5 pl-4">
            {marqueeItems.map((t, i) => (
              <span key={`${t.id}-${i}`} className="flex items-center gap-2 whitespace-nowrap text-xs text-foreground-300">
                <em className="not-italic font-medium text-accent-400">[{t.tag}]</em>
                <span>{t.text}</span>
                <em className="not-italic text-foreground-500">· {t.time}</em>
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* 主导航壳层 */}
      <div
        className={`border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-700/70 bg-background-950/85 backdrop-blur-md"
            : "border-transparent bg-background-950/40 backdrop-blur-sm"
        }`}
      >
        <div className="mx-auto flex max-w-[1280px] items-center justify-between px-4 py-3 md:px-6">
          {/* logo */}
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-eye-line text-lg text-background-950"></i>
            </span>
            <span className="leading-none">
              <span className="font-heading block text-lg font-bold tracking-tight text-foreground-50">
                吃瓜<span className="text-primary-400">黑网</span>
              </span>
              <span className="mt-0.5 block text-[10px] tracking-[0.2em] text-foreground-500">内幕 · 线索 · 求证</span>
            </span>
          </a>

          {/* 桌面导航 */}
          <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="rounded-md px-3 py-2 text-sm text-foreground-300 transition-colors hover:bg-background-800 hover:text-foreground-50"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <span className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-800 hover:text-foreground-100">
              <i className="ri-search-line text-lg"></i>
            </span>
            <a
              href="#cta"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-950 transition-colors hover:bg-primary-400"
            >
              我要爆料
            </a>
          </div>

          {/* 移动端按钮 */}
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-200 hover:bg-background-800 md:hidden"
          >
            <i className={`ri-${menuOpen ? "close-line" : "menu-3-line"} text-xl`}></i>
          </button>
        </div>

        {/* 移动端菜单 */}
        {menuOpen && (
          <div className="border-t border-background-800 bg-background-950/95 px-4 pb-5 pt-2 md:hidden">
            <nav className="grid grid-cols-2 gap-1" aria-label="移动导航">
              {navLinks.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setMenuOpen(false)}
                  className="rounded-md px-3 py-3 text-sm text-foreground-300 hover:bg-background-800 hover:text-foreground-50"
                >
                  {l.label}
                </a>
              ))}
            </nav>
            <a
              href="#cta"
              onClick={() => setMenuOpen(false)}
              className="mt-3 flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-950"
            >
              我要爆料
            </a>
          </div>
        )}
      </div>
    </header>
  );
}